/**
 * @generated SignedSource<<8c3d501c877ecc3695b7c642fb82ffbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModule_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ParticipativeModuleAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visualizationDisplayAuthorized",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ParticipativeModuleLayout_participativeModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ParticipativeModuleVisualization_participativeModule"
        }
      ],
      "type": "ParticipativeModule",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Event_participativeModule"
        }
      ],
      "type": "Event",
      "abstractKey": null
    }
  ],
  "type": "ParticipativeModuleInterface",
  "abstractKey": "__isParticipativeModuleInterface"
};

node.hash = "3927c6989cd6f952214b42e60eb4b40c";

module.exports = node;
